import { Redirect, Switch } from "react-router";

export default function RouteClosed() {
  return (
    <Switch>
      <Redirect to={"/"} />
    </Switch>
  );
}
